import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient, authApiClient } from '../../../utils/axios';
import { useState } from 'react';
import { AxiosError } from 'axios';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { isString } from 'lodash';

export const mutateProduct = async ({ payload }) => {
  const { data } = await authApiClient.patch(`/organization/settings/auto-numbering-enabled`, payload);
  return data;
};

export const useMutateAutoNumberingHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const { snackbarMessages } = useTranslatedMessages();
  const settingsMessages = snackbarMessages.settings ?? {};
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);

  const mutation = useMutation({
    mutationFn: mutateProduct,
    onSuccess: (data, variables) => {
      dispatch(showSnackbar({ message: settingsMessages.organization_settings_updated_success, severity: 'success' }));
      queryClient.invalidateQueries({ queryKey: ['org'] });
      onSuccess && onSuccess(variables);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        if (error.response.status === 400) {
          setError(error.response.data.errors);
          return;
        }
        if (error?.response?.data?.errors?.message) {
          dispatch(showSnackbar({ message: error?.response?.data?.errors?.message, severity: 'error' }));
          return;
        }
        dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
      } else {
        dispatch(
          showSnackbar({
            message: isString(error.message) ? error.message : JSON.stringify(error.message),
            severity: 'error',
          }),
        );
      }
    },
  });

  const onSubmit = async (payload, addOneMore) => {
    mutation.mutate({ payload, addOneMore });
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit: onSubmit,
  };
};
